import fsaActionCreatorFactory from "typescript-fsa";

/**
 * Action creator factory with service prefix.
 */
const actionCreatorFactory = () => fsaActionCreatorFactory("COMMON");

export default actionCreatorFactory;
